import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@/assets/images/check.svg';
import { Colors, Spacing } from '@/shared/theme';
import { Collapse } from '@mui/material';
import styled from 'styled-components';

const ListItem = styled.div<{ valid: boolean }>`
  color: ${props => (props.valid ? Colors.foregroundDisabledAlt : Colors.hint || Colors.foregroundDisabled)};
  text-decoration: ${props => (props.valid ? 'line-through' : 'none')};
  margin-bottom: ${Spacing.x1}px;
`;

const StyledBullet = styled.div`
  display: inline-block;
  color: ${Colors.hint || Colors.foregroundDisabled};
  font-size: 14px;
  width: 16px;
  height: 16px;
`;

const CheckIconElement = () => <img src={CheckIcon} alt="Check Icon" height={16} width={16} />;

const StyledCheckIconElement = styled(CheckIconElement)`
  vertical-align: middle;
`;

type Props = {
  value: string;
  isFocused?: boolean;
  id?: string;
};

const PasswordHelper: React.FC<Props> = ({ value, isFocused, id }) => {
  const { t } = useTranslation();
  const passwordTests = [
    {
      label: t('form.password-hint.length'),
      test: value.length >= 8,
    },
    {
      label: t('form.password-hint.special'),
      test: /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(value),
    },
    {
      label: t('form.password-hint.upper'),
      test: /[A-Z]/.test(value),
    },
    {
      label: t('form.password-hint.lower'),
      test: /[a-z]/.test(value),
    },
  ];

  const passedAllTests = passwordTests.every(item => item.test);

  return (
    <Collapse in={isFocused && !passedAllTests}>
      <div id={id}>
        {passwordTests.map(({ label, test }) => (
          <ListItem key={label} valid={test}>
            <StyledBullet>{test ? <StyledCheckIconElement /> : '•'}</StyledBullet>
            {label}
          </ListItem>
        ))}
      </div>
    </Collapse>
  );
};

export { PasswordHelper };
